import { useEffect, useState } from "react";
import { CrumbProps } from "../BreadcrumbSocialShare/C45_Breadcrumb";
import { GlobalContent } from "./Layout.interfaces";

const useBreadcrumbs = (referPage: string, globalContent: GlobalContent) => {
  const [breadcrumbs, setBreadcrumbs] = useState(globalContent?.breadcrumbs);

  useEffect(() => {
    if (!referPage) {
      setBreadcrumbs(globalContent?.breadcrumbs);
      return;
    }

    const fetchBreadcrumbs = async () => {
      const pageUrl: string = referPage.replace(referPage.charAt(0), "");
      let url: string = "";
      const dynamicBreadcrumbs: CrumbProps[] = await Promise.all(
        pageUrl.split("/").map(async (crumb, i): Promise<CrumbProps> => {
          url += i === 0 ? crumb : `/${crumb}`;
          const crumbUrl: string = url;

          const entry = await (
            await fetch(`/api/getEntryBySlug?slug=${url}`)
          ).json();

          return {
            url: crumbUrl,
            title: entry.title,
          };
        })
      );

      setBreadcrumbs(dynamicBreadcrumbs);
    };

    fetchBreadcrumbs();
  }, [referPage, globalContent]);

  return breadcrumbs;
};

export default useBreadcrumbs;
